<template>
    <div class="editVote">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>投票</el-breadcrumb-item>
            <el-breadcrumb-item>编辑模板</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="edit-vote-box">
            <div class="vote-list-box">
                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                <el-tree class="tree" :data="voteList" ref="voteTree" :props="propsRules" :filter-node-method="filterNode" @node-click="selectVote" :highlight-current="true"></el-tree>
            </div>
            <div class="vote-contents-box" v-if="voteOptions">
                <div class="header-image">
                    <img :src="currentVote.bgimg" >
                </div>
                <div class="vote-info">
                    <div class="description">
                        <div class="desc-icon">概述</div>
                        <span class="desc-content">{{currentVote.vote_content}}</span>
                    </div>
                    <div class="vote-time-box">
                        <div class="begin-time">
                            <span>开始时间：</span>
                            <span>{{formatBeginDate}}</span>
                        </div>
                        <div class="end-time">
                            <span>截止时间：</span>
                            <span>{{formatEndDate}}</span>
                        </div>
                    </div>
                </div>
                <div class="vote-content">
                    <div class="go-ranking">查看排名</div>
                    <div class="vote-options-box">
                        <ul>
                            <li v-for="(optionItem,index) in voteOptions" :key="optionItem.options_id">
                                <div class="option-item-box" v-bind:class="{'right' : index%2}">
                                    <div class="image-box">
                                        <img :src="optionItem.options_img" >
                                    </div>
                                    <div class="title-box">{{optionItem.options_name}}</div>
                                    <div class="option-manage-box">
                                        <el-button-group>
                                            <el-button type="primary" icon="edit" size="mini" @click="openEditDialog(index)"></el-button>
                                            <el-button type="primary" icon="delete" size="mini" @click="deleteVoteOption(optionItem.options_id)"></el-button>
                                        </el-button-group>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="add-vote-item-box" v-if="currentVote">
                <div>
                    <div class="header">投票选项</div>
                    <div class="body">
                        <el-form label-position="top" :model="addVoteOptionForm" :rules="validateRules" ref="addVoteOptionForm" label-width="100px" class="addVoteOptionForm">
                            <el-form-item label="标题" prop="options_name">
                                <el-input v-model="addVoteOptionForm.options_name" placeholder="请填写选项标题"></el-input>
                            </el-form-item>
                            <el-form-item label="描述" prop="options_content">
                                <el-input type="textarea" v-model="addVoteOptionForm.options_content" placeholder="请填写选项描述"></el-input>
                            </el-form-item>
                            <el-form-item label="焦点图" prop="options_img">
                                <el-input v-model="addVoteOptionForm.options_img" placeholder="请填写选项焦点图（尺寸2：3）链接"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="addVoteOption('addVoteOptionForm')">立即创建</el-button>
                                <el-button @click="clearVoteOptionFormData()">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="编辑选项" v-model="config.editVoteOption.visible" :lock-scroll="true" @close="clearDialogData">
            <el-form :model="editVoteOptionForm" :rules="config.editVoteOption.validateRules" ref="editVoteOptionForm">
                <el-form-item label="标题" :label-width="config.editVoteOption.formLabelWidth" prop="options_name">
                    <el-input type="text" v-model="editVoteOptionForm.options_name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="描述" :label-width="config.editVoteOption.formLabelWidth" prop="options_content">
                    <el-input type="textarea" v-model="editVoteOptionForm.options_content" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="焦点图" :label-width="config.editVoteOption.formLabelWidth" prop="options_img">
                    <el-input type="text" v-model="editVoteOptionForm.options_img" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="config.editVoteOption.visible = false">取 消</el-button>
                <el-button type="primary" @click="updateVoteOption('editVoteOptionForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "editVote",
    data() {
        return {
            filterText: null,
            voteList: null,
            voteOptions: null,
            currentVote: null,
            showControl: true,
            propsRules: {
                children: null,
                label: "vote_name"
            },
            addVoteOptionForm: {
                options_name: null,
                options_content: null,
                options_img: null,
                vote_id: null
            },
            editVoteOptionForm: {
                options_id: null,
                options_name: null,
                options_content: null,
                options_img: null
            },
            validateRules: {
                options_name: [
                    { required: true, message: '请填写选项名称', trigger: 'blur' }
                ],
                options_content: [
                    { required: true, message: '请填写选项描述', trigger: 'blur' }
                ],
                options_img: [
                    { required: true, message: '请填写选项焦点图链接', trigger: 'blur' }
                ]
            },
            config: {
                editVoteOption: {
                    visible: false,
                    formLabelWidth: '120px',
                    validateRules: {
                        options_name: [
                            { required: true, message: '请填写选项名称', trigger: 'blur' }
                        ],
                        options_content: [
                            { required: true, message: '请填写选项描述', trigger: 'blur' }
                        ],
                        options_img: [
                            { required: true, message: '请填写选项焦点图链接', trigger: 'blur' }
                        ]
                    },
                }
            }
        };
    },
    watch: {
        filterText(val) {
            this.$refs.voteTree.filter(val);
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo'
        }),
        formatBeginDate(){
            return moment(parseInt(this.currentVote.vote_start_time)).format('YYYY-MM-DD HH:mm:ss');
        },
        formatEndDate(){
            return moment(parseInt(this.currentVote.vote_end_time)).format('YYYY-MM-DD HH:mm:ss');
        }
    },
    mounted(){
        this._init();
    },
    methods: {
        _getVoteList(){
            this.$http.get(CONFIG.HOST + '/voteSystem/vote/getVoteList').then((response)=>{
                let result =response.body;
                if (result && result.status === 1) {
                    this.voteList =result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _getVoteOptions(){
            let voteId = this.currentVote.vote_id;
            this.$http.get(`${CONFIG.HOST}/voteSystem/vote/getOptionsByVoteId/${voteId}`).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.voteOptions = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);          
        },
        filterNode(value, data) {
            if (!value){
                return true;
            } 
            return data.specialName.indexOf(value) !== -1;
        },
        selectVote(data){
            this.voteOptions = null;
            this.currentVote = data;
            console.log(this.currentVote);
            this.addVoteOptionForm.vote_id = this.currentVote.vote_id;
            this._getVoteOptions();
        },
        clearVoteOptionFormData(){
            for (let key in this.addVoteOptionForm) {
                if (key !== 'vote_id') {
                    this.addVoteOptionForm[key] = null;
                }
            }
        },
        addVoteOption(formName){
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$http.post(CONFIG.HOST + '/voteSystem/vote/addVoteOptions', this.addVoteOptionForm).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: `【营销平台】名称为：${this.addVoteOptionForm.options_name}的选项添加成功`
                    });
                    this._getVoteOptions();
                    this.clearVoteOptionFormData();
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        deleteVoteOption(optionId){
            this._confirmMessage(`是否确定删除optionId= ${optionId} 的选项？`, ()=>{
                if (optionId < 0) {
                    this.$notify.error({
                        message: `【营销平台】optionId= ${optionId} 的选项不存在`
                    });
                    return;
                }
                this.$http.delete(`${CONFIG.HOST}/voteSystem/vote/deleteOptionById/${optionId}`).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: `【营销平台】ID为：${optionId}的选项删除成功`
                        });
                        this._getVoteOptions();
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                },(response)=>{
                    console.log(response);
                });
            });
        },
        clearDialogData(){
            for (let key in this.editVoteOptionForm) {
                this.editVoteOptionForm[key] = null;
            }
        },
        updateVoteOption(formName){
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$http.put(`${CONFIG.HOST}/voteSystem/vote/updateOptionById`, this.editVoteOptionForm).then((response)=>{
                let result =response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: `【营销平台】ID为：${this.editVoteOptionForm.options_id}的选项更新成功`
                    });
                    this._getVoteOptions();
                    this.config.editVoteOption.visible = false;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        openEditDialog(arrIndex){
            this.config.editVoteOption.visible = true;
            let currOption = this.voteOptions[arrIndex];
            for (let key in currOption) {
                this.editVoteOptionForm[key] = currOption[key];
            }
        },
        _init() {
            this._getVoteList();
        }
    }
};
</script>
<style lang="less">
    .editVote{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .edit-vote-box{
            width: 980px;
            position: relative;
            left: 0;
            top: 0;

            .vote-list-box{
                width: 280px;
                float: left;

                .tree{
                    margin-top: 6px;
                    
                    .el-tree-node__expand-icon.is-leaf{
                        display: none;
                    }
                    .is-current{
                        .el-tree-node__content{
                            background-color: #324157;
                        }
                        color: #fff;
                    }
                }
            }
            .vote-contents-box{
                width: 320px !important;
                height: 560px;
                overflow-y: auto;
                margin-bottom: 10px;
                position: relative;

                text-align: left;
                color: rgb(51, 51, 51);

                float: left;
                margin-left: 20px;

                border: 1px solid #bfcbd9;
                .header-image{
                    width: 100%;
                    display: block;
                    img{
                        width: 100%;
                    }
                }
                .vote-info{
                    font-size: 13px;
                    padding: 0 10px 10px;
                    margin-bottom: 10px;
                    border-bottom: 1px solid #bfcbd9;
                    .label{
                        color: #f34c3f;
                    }
                    .description{
                        .desc-icon{
                            color: #fff;
                            background: #f34c3f;
                            display: inline-flex;
                            padding-left: 2px;
                            padding-right: 2px;
                        }
                    }
                    .vote-time-box{
                        .begin-time{

                        }
                        .end-time{

                        }
                    }
                }
                .vote-content{
                    padding: 0 10px;
                    .go-ranking{
                        color: #fff;
                        background: #f34c3f;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        border-radius: 4px;
                    }
                    .vote-options-box{
                        margin-top: 10px;
                        ul, ol, li{
                            list-style-type: none;
                        }
                        .option-item-box{
                            width: 48%;
                            height: 250px;
                            background: #ececec;
                            overflow: hidden;

                            margin-bottom: 6px;
                            float: left;
                            .image-box{
                                width: 100%;
                                height: 200px;
                                img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .title-box{
                                font-size: 14px;
                                text-align: center;
                                overflow: hidden;
                            }
                            .option-manage-box{
                                
                            }
                        }
                        .right{
                            margin-left: 4%;
                        }
                    }
                }
            }
            .add-vote-item-box{
                width: 340px;
                float: left;
                margin-left: 15px;
                
                text-align: left;
                border: 1px solid #bfcbd9;
                .header{
                    padding: 10px 14px;
                    
                    border-bottom: 1px solid #bfcbd9;
                    
                    color: rgb(51, 51, 51);
                }
                .body{
                    padding: 20px 10px 0;
                }
            }
        }
        .box-card{
            margin-bottom: 10px;
        }
    }  
</style>


// WEBPACK FOOTER //
// Edit.vue?e7ff4584